import { createAction } from '@reduxjs/toolkit';
import { GetSchedulesParams, Schedule } from '@innovyze/stylovyze';
import { addNamespace } from '@Utils/actions';

export const getTenantSchedules = createAction<GetSchedulesParams>(
	addNamespace('configurations/getTenantSchedules'),
);

export const getTenantSchedulesResolved = createAction<Schedule[]>(
	addNamespace('configurations/getTenantSchedules/resolved'),
);
